<template>
  <div class="order-detail">
    <div class="header">
      <TopBar :title ="$t('exchangePage.detail')" />
    </div>
    <div class="body">
      <div class="card">
        <div class="left">
          <van-image
            width="1.8rem"
            height="1.8rem"
            :src="detail.thumbImageUrl"
          />
        </div>
        <div class="right">
          <div class="name">{{detail.giftName}}</div>
          <div class="money">{{$t('xhjb')}} <van-icon name="points" /> {{detail.displayPoints}}</div>
          <div class="count">{{$t('dhsj')}} {{ detail.orderDate }}</div>
        </div>
      </div>

      <div class="divider"></div>

      <div>
        <van-steps direction="vertical" :active="active" finish-icon="checked">
          <van-step v-if="detail.orderDate !== ''">
            <h3>{{$t('orderStatus1')}}</h3>
            <p>{{ detail.orderDate }}</p>
          </van-step>
          <van-step v-if="detail.confirmDate !== ''">
            <h3>{{$t('orderStatus2')}}</h3>
            <p>{{ detail.confirmDate }}</p>
          </van-step>
          <van-step v-if="(active === 1 || active === 2) && detail.checkDate === ''">
            <h3>{{$t('orderStatus7')}}</h3>
          </van-step>
          <van-step v-if="active !== 3 && active !== 4 && detail.checkDate !== ''">
            <h3>{{$t('orderStatus3')}}</h3>
            <p>{{ detail.checkDate }}</p>
          </van-step>
          <van-step v-if="active === 3">
            <h3>{{$t('orderStatus4')}}</h3>
            <p>{{ detail.checkDate }}</p>
            <p>{{ detail.memo }}</p>
          </van-step>
          <van-step v-if="active === 4">
            <h3>{{$t('orderStatus5')}}</h3>
            <p>{{ detail.checkDate }}</p>
            <p>{{ detail.memo }}</p>
          </van-step>
          <van-step v-if="active !== 3 && active !== 4 && detail.checkDate !== ''">
            <h3>{{$t('orderStatus6')}}</h3>
            <p>{{ detail.checkDate }}</p>
            <p>{{ detail.memo }}</p>
          </van-step>
        </van-steps>
    </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {GiftsDetail,handleOrder,OrdersDetail} from '@/api/api.js';
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'OrderDetail',
    components: {
      TopBar
    },
    data () {
      return {
        showDialog:false,
        showUpdateDialog:false,
        hasInfo:true,
        id:0,
        detail:{},
        active:0,
        confirmDate:''
      }
    },
    watch: {
        'id'(val){
          if(val){
            this.getOrderDetail()
          }
        }
    },
    methods: {
      onClickLeft(){
        this.$router.go(-1)
      },
      getOrderDetail(){
        const params = {
          id:this.$route.query.id
        }
        OrdersDetail(params).then(res=>{
          if(res.code === 200) {
            this.detail = res.data;
            if(this.detail.statusID === 1) this.active = 2;
            else if(this.detail.statusID === 2) this.active = 5;
            else this.active = this.detail.statusID || 0
            //this.active = this.detail.statusID || 0
            this.confirmDate = this.detail.confirmDate ||''
          }else{
            Notify({ type: 'warning', message: res.errors[0]||this.$t("httpErrors.systemError") });
          }
        })
        },
    },
    mounted () {
      this.id = this.$route.query.id
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.order-detail{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #f3f3f3;
    .body{
      background: white;
      height: calc(100% - 90px);
      margin: 20px;
      border-radius: 9px;
      .card{
        border-radius: .2rem;
        height:2.2rem;
        background: #ffffff;
        display: flex;
        align-items: center;
        font-weight:bold;
        padding-top: .3rem;
        .left{
          margin-left:.2rem;
          border-radius: 9px;
          overflow: hidden;
        }
        .right{
          margin-left: .5rem;
          .money{
            color: #F67E3D
            margin-top:.3rem;
            margin-bottom:.3rem;
          }
          .count{
            color:#8E8D8D;
          }
        }
      }
    }
    .footer{
      padding:0 .4rem;
    }
    .divider{
      height: 1px;
      background-color: #f4f4f4;
      width: calc(100% - 20px);
      margin: auto;
      margin: 10px;
    }
  }
  /deep/ .van-step--vertical:not(:last-child)::after{
    border-bottom-width: 0;
  }

  /deep/ .van-step__line{
    background-color: #07c160;
    top: 27px;
    height: 75%;
  }

  /deep/ .van-step__title{
    color: #07c160;
  }

 /deep/ .van-step__circle{
    background-color: #07c160;
 } 
</style>
<style lang="stylus">
  .noticeWidth {
    min-width: 40vw;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orderDetail/OrderDetail.vue